<!--
component: BrowseDaichoEdited
author: Takumi Ogura
description: 台帳記載証明閲覧画面
-->
<template>
	<section class="daicho">
		<v-container fluid class="pt-0 px-0">
			<div class="head-message">{{ message }}</div>
			<v-row class="pt-2" justify="center">
				<v-col align-self="center">
					<v-card :height="$vuetify.breakpoint.height - 200" width="100%" class="mx-auto" style="overflow: visible;">
						<v-row>
							<v-col cols="4" sm="5" md="5" class="py-0 pr-0">
								<v-row class="ma-1 orange lighten-2 overflow-y-auto" :style="'height:' + ($vuetify.breakpoint.height - 217) + 'px;'">
									<v-col>
										<!-- 受付番号 -->
										<v-row style="white-space: nowrap;">
											<v-col class="pb-1">
												<v-row align="center">
													<v-col align="left" cols="3">
														&nbsp;受付番号
													</v-col>
													<v-col cols="9">
														<v-text-field filled hide-details dense class="align-center" v-model="ledgerData.rcpNo" readonly>
															<template v-slot:prepend>
																<span class="">第</span>
															</template>
															<template v-slot:append-outer>
																<span>号</span>
															</template>
														</v-text-field>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
										<!-- 確認番号 -->
										<v-row style="white-space: nowrap;">
											<v-col class="py-1">
												<v-row align="center">
													<v-col align="left" cols="3">
														&nbsp;確認番号
													</v-col>
													<v-col cols="9">
														<v-text-field filled hide-details dense class="align-center" v-model="ledgerData.cnfNo" readonly>
															<template v-slot:prepend>
																<span>第</span>
															</template>
															<template v-slot:append-outer>
																<span>号</span>
															</template>
														</v-text-field>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
										<!-- 発行系 -->
										<v-row>
											<v-col class="pt-0">
												<v-card class="orange lighten-4">
													<v-row class="ma-1" style="white-space: nowrap;">
														<v-col class="py-2">
															<v-row>
																<v-col class="pb-1">
																	<v-row align="center">
																		<v-col cols="4" align="left" class="px-1">&nbsp;発行番号</v-col>
																		<v-col cols="8" class="px-1">
																			<v-tooltip top>
																				<template v-slot:activator="{ on, attrs }">
																					<v-text-field
																						solo hide-details dense class="align-center"
																						style="font-size:16px !important;"
																						v-model="ledgerData.issue.no"
																						maxLength="5"
																						v-bind="attrs"
																						v-on="on">
																						<template v-slot:prepend>
																							<span>第</span>
																						</template>
																						<template v-slot:append-outer>
																							<span>号</span>
																						</template>
																					</v-text-field>
																				</template>
																				<span>5桁まで入力可能です。</span>
																			</v-tooltip>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
															<v-row>
																<v-col class="py-1">
																	<v-row align="center">
																		<v-col cols="4" align="left" class="px-1">&nbsp;発行日</v-col>
																		<v-col cols="8" align="center" class="px-1">
																			<DatePicker ref="issueDatePicker" v-model="create_date" @clear="ledgerData.issue.date = $event"/>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
															<v-row>
																<v-col class="py-1">
																	<v-row align="center">
																		<v-col cols="4" align="left" class="px-1">&nbsp;発行者氏名</v-col>
																		<v-col cols="8" class="px-1">
																			<v-text-field solo hide-details dense v-model="ledgerData.issue.person"></v-text-field>
																		</v-col>
																	</v-row>
																</v-col>
															</v-row>
														</v-col>
													</v-row>
												</v-card>
											</v-col>
										</v-row>
										
										<!-- 印刷ボタン -->
										<v-row class="mt-1">
											<v-col class="pt-3">
												<v-row justify="center">
													<v-col  cols="4" align="right">
														<v-btn large block color="success" @click="exePrint"><v-icon>mdi-printer</v-icon>&nbsp;印刷</v-btn>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
							<!-- 台帳記載証明書View -->
							<v-col cols="8" sm="7" md="7" class="py-0 pl-0 preview-col">
								<!-- 様式1: 申請書 (プレビュー表示) -->
								<v-row class="ma-1 preview-pane overflow-y-auto" :style="'max-height:' + ($vuetify.breakpoint.height - 217) + 'px;'" style="border-style: groove; background-color: gray;">
									<v-col class="pt-0 ma-1">
										<BrowseDaichoView :data="ledgerData" type="appForm"/>
									</v-col>
								</v-row>
								<!-- 印刷用: 様式1と様式2(非表示、印刷時のみ使用) -->
								<div style="display: none;">
									<BrowseDaichoView :data="ledgerData" type="appForm"/>
									<BrowseDaichoView :data="ledgerData" type="certificate"/>
								</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
			<!-- 印刷ボタンダイアログ -->
			<!--
			<v-dialog id="printDialog" width="30%" v-model="printDialog">
				<v-card>
					<v-card-title><v-icon large>mdi-printer</v-icon>&nbsp;記載証明書印刷</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-row>
							<v-col>
								<v-radio-group
									v-model="printType"
									mandatory
									hide-details
								>
									<v-radio
										label="申請書"
										value="0"
									></v-radio>
									<v-radio
										label="証明書"
										value="1"
									></v-radio>
									<v-radio
										label="申請書および証明書の一括出力"
										value="2"
									></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
								<v-btn
									color="green darken-1"
									text
									@click="printDialog = false"
								>
									キャンセル
								</v-btn>
								<v-btn
									color="green darken-1"
									text
									@click="exePrint()"
								>
									OK
								</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			-->
			<!-- フラッシュメッセージダイアログ -->
			<v-dialog v-model="flashDialog" width="30%">
				<v-card>
					<v-card-title class="text-h6 px-5">
						<v-icon large color="success">mdi-checkbox-marked-circle-outline</v-icon>&nbsp;確認メッセージ
					</v-card-title>
					<v-card-text class="pb-0">
						コメントを登録しました。
					</v-card-text>
					<v-card-actions class="pt-0">
						<v-spacer></v-spacer>
						<v-btn text color="success" @click="flashDialog = false">OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
        :title="'ユーザー認証'" :body="'ユーザー認証に失敗しました。ログインし直して下さい。'"/>
		</v-container>
	</section>
</template>
<script>
import BrowseDaichoView from '../components/BrowseDaichoKenchikuView.vue'
import Dialog from '../components/Dialog.vue'
import DatePicker from '../components/DatePicker.vue'
//import DatePicker from '../components/DatePickerWareki.vue'
//import Const from '../common/constants.js'
import { callGetApi, callPostApi, registLog } from '../common/apiAccess'
import { apiUrl, getWardCodeBalicsShortname } from '../common/utils'
export default {
	name: 'browsedaicho',
	components:{
		BrowseDaichoView,
		DatePicker,
		Dialog
	},
	data(){
		return {
			ledgerData:{
				constructType: [],
				rcpNo: '',
				cnfNo: '',
				issue:{
					no: null,
					date: this.formatDate(new Date()),
					person: '横浜市長　山中 竹春',
					ledgerType: '確認申請台帳',
					shubetsu: '',
				},
				build:{
					gaiyo:{
						placeLotNo: '',
						mainUse: '',
						siteArea: null,
						unitSiteArea: null,
						unitBuildAreaApp: null,
						buildAreaNotApp: null,
						unitTotalAreaApp: null,
						totalAreaNotApp: null,
						struct: '',
						ground: null,
						underGround: null,
						buildNum: null,
					},
					architectInfo:{
						address: '',
						company: '',
						position: '',
						name: '',
						joinNum: null,
						joinPerson: [],
					},
					comment: '',
				},
				kknnNo: null,
				kknnDay: null,
				henkoNo: null,
				henkoDay: null,
				chukanNo1: null,
				chukanDay1: null,
				chukanNo2: null,
				chukanDay2: null,
				kenzumiNo: null,
				kenzumiDay: null,
				flg_kenzumi: null,
			},
			ledgerType: ['確認申請台帳','変更申請台帳','中間検査台帳','完了検査台帳','建築確認台帳'],
			tab: null,
			tabItems:['建築物の概要','建築主','コメント'],
			personList: ['a','b','c'],
			printDialog: false,
			printType: "0",
			flashDialog: false,
			// メッセージダイアログ
			authDialog: false,
			create_date: this.formatDate(new Date()),
		}
	},
	watch: {
		create_date(newValue, oldValue) {
			if(newValue !== oldValue) {
				const datePickerInstance = this.$refs.issueDatePicker;
				datePickerInstance.pickerText = newValue;
				this.ledgerData.issue.date = newValue;
				datePickerInstance.inputDate();
				this.setDanchoNo();
			}
		},
	},
	computed:{
		mode: {
			get() { return this.$store.state.mode; },
			set(val) { this.$store.commit('setMode', val); }
		},
		token () {
			return this.$store.state.token;
		},
		unauthorized () {
			return this.token == undefined || this.token == null || this.token.length == 0;
		},
		authorized () {
			return !this.unauthorized;
		},
		message () {
			return "台帳記載証明書";
		},
		date: {
			get() {
//				return this.formatDate(new Date());
				return this.ledgerData.issue.date;
			},
			set(val) {
				this.ledgerData.issue.date = val;
				//年度内開庁日の連番を取得し格納
        const url = apiUrl('KisaiNo') + '?date=' + val;
				const self = this;
        callGetApi(url, (data) => {
          if (data.errorCode === undefined) {
						//self.ledgerData.issue.no = "11"+String(data-11000);
						var v = (data % 11000).toString();
						self.ledgerData.issue.no = "11"+v.padStart(3, '0');
          }
        });
			}
		}
	},
	mounted() {
		if (this.unauthorized) {
			this.authDialog = true;
		}
		this.$store.commit('setCurrentPage', 3);
		this.message = '';
    // APIで取得したデータをセット
		var daicho_list = this.$store.state.daicho;
		var daicho_index = this.$store.state.seldaichoIndex;

		//			var daicho_item = this.$store.state.seldaicho;
		var dbData = daicho_list[daicho_index];
		console.log(dbData);

		var sikibetsu = dbData.nen +getWardCodeBalicsShortname(dbData.gyosei_kubun)+ dbData.bango;

		//console.log(dbData);
		this.ledgerData.rcpNo = sikibetsu != null ? sikibetsu : '';
		this.ledgerData.cnfNo = sikibetsu != null ? sikibetsu : '';
		this.ledgerData.issue.no = dbData.bango;
		this.ledgerData.issue.date = this.formatDate(new Date());
		const datePickerInstance = this.$refs.issueDatePicker;
		datePickerInstance.pickerText = this.create_date;
		datePickerInstance.inputDate();

		//this.ledgerData.issue.date = dbData.date != null ? dbData.knn_day.replaceAll('/','-') : '';
		this.ledgerData.issue.ledgerType = "XXXX-1";
		this.ledgerData.ukeNo = sikibetsu;
		this.ledgerData.ukeDay = this.formatDateWareki(dbData.uke_day);
		this.ledgerData.kknnNo = sikibetsu;
		this.ledgerData.kknnDay = this.formatDateWareki(dbData.kknn_day);
		this.ledgerData.henkoNo = sikibetsu;
		this.ledgerData.henkoDay = this.formatDateWareki(dbData.kknn_day);
		this.ledgerData.chukanNo1 = sikibetsu;
		this.ledgerData.chukanDay1 = this.formatDateWareki(dbData.kenzumi_day);
		this.ledgerData.build.gaiyo.placeLotNo1 = dbData.bkn_addr1;
		this.ledgerData.build.gaiyo.placeLotNo2 = dbData.bkn_addr2;
		this.ledgerData.build.gaiyo.mainUse = dbData.gutai_syuyo_yoto;
		this.ledgerData.build.gaiyo.siteArea = this.setValue(dbData.site_area);
		this.ledgerData.build.gaiyo.buildAreaApp = this.setValue(dbData.bld_area);
		this.ledgerData.build.gaiyo.buildAreaNotApp = dbData.nb_area;
		//this.ledgerData.build.gaiyo.totalAreaApp = this.setValue(dbData.site_area+dbData.bld_area);
		this.ledgerData.build.gaiyo.totalAreaApp = this.setValue(dbData.nb_area);

		this.ledgerData.build.gaiyo.unitSiteArea = dbData.unit_site_area;
		this.ledgerData.build.gaiyo.unitBuildAreaApp = dbData.unit_bld_area;
		this.ledgerData.build.gaiyo.unitTotalAreaApp = dbData.unit_nb_area;

		this.ledgerData.build.gaiyo.constructType = dbData.gutai_koji_sybt;
		this.ledgerData.build.gaiyo.struct = dbData.gutai_kozo_sybt;
		this.ledgerData.build.gaiyo.ground = (dbData.tijo_kaisu || "-");
		this.ledgerData.build.gaiyo.underGround = (dbData.tika_kaisu || "-");
		this.ledgerData.build.gaiyo.buildNum = (dbData.sns_bld_su || "-");
		this.ledgerData.build.architectInfo.address1 = (dbData.bldr_addr1 || "");
		this.ledgerData.build.architectInfo.address2 = (dbData.bldr_addr2 || "");
		this.ledgerData.build.architectInfo.name1 = (dbData.bldr_name1 || "");
		this.ledgerData.build.architectInfo.name2 = (dbData.bldr_name2 || "");
		this.ledgerData.build.architectInfo.joinNum = (dbData.bldr_other_cnt || "-");
		this.ledgerData.flg_kenzumi = dbData.flg_kenzumi;
		//this.ledgerData.build.architectInfo.address = (dbData.bldr_addr1 || "") + (dbData.bldr_addr2 || "");
		//this.ledgerData.build.architectInfo.name = (dbData.bldr_name1 || "")+(dbData.bldr_name2 || "");
		//this.ledgerData.build.architectInfo.joinNum = (dbData.bldr_other_cnt || "0");

		this.setDanchoNo();

		// 閲覧ログ取得
		registLog([[104, '台帳記載証明書閲覧', this.ledgerData.rcpNo, this.ledgerData.cnfNo],]);
		},
	methods: {
		formatDateWareki(date_str) {
			if(!date_str) return "記載なし";
			date_str = date_str.split('T')[0];
			let [year, month, day] = date_str.split('-');
			if (typeof month === 'undefined' || month === '') {
				return "記載なし";
			}
			if (typeof day === 'undefined' || day === '') {
				return "記載なし";
			}
			month = ('00' + month).slice(-2).replace(/^0/, ' ');
			day = ('00' + day).slice(-2).replace(/^0/, ' ');

			const wareki = this.convertToWareki(year,month,day);
			const warekiYear = parseInt(year) - wareki.startYear + 1;
			return `${wareki.era}${warekiYear}年${month}月${day}日`;
		},
		convertToWareki(year,month,day) {
			// 令和：2019年5月1日以降
			if (year >= 2019) {
				return { era: '令和', startYear: 2019 };
			} else if (year >= 1989) {
			// 平成：1989年1月8日以降
				if (year == 1989 && month == 1 && day <= 7) {
						return { era: '昭和', startYear: 1926 };
				} else {
						return { era: '平成', startYear: 1989 };
				}
			} else if (year >= 1926) {
				return { era: '昭和', startYear: 1926 };
			} else if (year >= 1912) {
				return { era: '大正', startYear: 1912 };
			} else {
				return { era: '明治', startYear: 1868 };
			}
		},
		setDanchoNo() {
			var val = this.ledgerData.issue.date;
			
			const url = apiUrl('KisaiNo') + '?date=' + val;
			const self = this;
			callGetApi(url, (data) => {
				if (data.errorCode === undefined) {
					//self.ledgerData.issue.no = "11"+String(data-11000);
					var v = (data % 11000).toString();
					self.ledgerData.issue.no = "11"+v.padStart(3, '0');
				}
			});
		},
		setValue(value) {
		//	return value !== null ? parseFloat(value).toFixed(2) : '-';
			const num = parseFloat(value);
			//return !isNaN(num) ? num.toFixed(2) : '-';
			return !isNaN(num) ? num : '-';
		},
		// 印刷処理
		exePrint() {
			// 記載証明発行ログを記録
			registLog([
					[103, '台帳記載証明書発行[申請書]', this.ledgerData.rcpNo, this.ledgerData.cnfNo],
					[103, '台帳記載証明書発行[証明書]', this.ledgerData.rcpNo, this.ledgerData.cnfNo]
				]);

			this.printDialog = false;
			// ダイアログが閉じて以下を実行
			setTimeout(() => {
				// 各ページを独立して取得（非表示の印刷用要素から取得）
				var hiddenContainer = document.querySelector('.preview-col > div[style*="display: none"]');
				var appFormPage = hiddenContainer.querySelector('.type-appForm');
				var certificatePage = hiddenContainer.querySelector('.type-certificate');
				
				// body内を非表示
				document.body.getElementsByTagName('noscript')[0].style.display = 'none';
				document.body.getElementsByTagName('div')[0].style.display = 'none';
				
				// 印刷用コンテナを作成
				var printContainer = document.createElement('div');
				printContainer.setAttribute('id','print');
				printContainer.setAttribute('style','width: 210mm !important;');
				
				// 1ページ目(appForm)をクローンして追加（注意文はそのまま）
				var page1Clone = appFormPage.cloneNode(true);
				page1Clone.style.cssText = 'height: 297mm !important; width: 210mm !important; position: relative; page-break-after: always;';
				printContainer.appendChild(page1Clone);
				
				// 2ページ目(certificate)をクローンして追加（注意文はそのまま）
				var page2Clone = certificatePage.cloneNode(true);
				page2Clone.style.cssText = 'height: 297mm !important; width: 210mm !important; position: relative;';
				printContainer.appendChild(page2Clone);
				
				document.body.appendChild(printContainer);
				
				const restoreDisplay = () => {
					printContainer.remove();
					document.body.getElementsByTagName('noscript')[0].style.display = 'block';
					document.body.getElementsByTagName('div')[0].style.display = 'block';
				};
				window.onafterprint = restoreDisplay;
				// 印刷
				window.print();
				restoreDisplay();
			},500);
		},
		// 建築主数更新処理および連名者氏名入力制御
		updateJoinNum() {
		// if(this.ledgerData.build.architectInfo.joinPerson.length <= 10){
			if(this.ledgerData.build.architectInfo.name != ''){
				this.ledgerData.build.architectInfo.joinNum = 1 + this.ledgerData.build.architectInfo.joinPerson.length;
			}else {
				this.ledgerData.build.architectInfo.joinNum = this.ledgerData.build.architectInfo.joinPerson.length;
			}
		// }else{
		// 	this.ledgerData.build.architectInfo.joinPerson.pop();
		// }
		
		},
		formatDate(date){
			if(date != '' && date != null){
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0'); // 月は0から始まるため、1を加えます
				const day = String(date.getDate()).padStart(2, '0');
				const formattedDate = `${year}-${month}-${day}`;
				return formattedDate;
			}else {
				return '';
			}
		},
		// 日付変換処理(0埋めで来る値を空白に変換 ex:平成09年12月01日 → 平成 9年12月 1日)
		convDate(date){
			if(date == '' || date == null){
				return '';
			}

			const text = String(date);
			const match = text.match(/^(.*?)(元|\d+)年(\d{1,2})月(\d{1,2})日$/);
			if (!match) {
				return text;
			}

			const era = match[1];
			const year = match[2];
			const month = match[3].padStart(2, ' ');
			const day = match[4].padStart(2, ' ');
			return `${era}${year}年${month}月${day}日`;
		},
		// コメント登録
		registComment() {
			// 登録処理
			this.flashDialog = true;
			// setTimeout(() => {
			// 	this.flashDialog = false;
			// },3000);
			const param = { ukeNo: this.ledgerData.rcpNo, comment: this.ledgerData.build.comment };
			callPostApi(apiUrl('KisaiComment'), param, () => {
					this.flashDialog = false;
			});
		},
	},
}
</script>
<style scoped>
.v-input{
	font-size: 10pt !important;
}
@media print {
	@page{
		margin-left: 8mm !important;
		margin-right: 8mm !important;
		margin-top: 12mm !important;
		margin-bottom: 5mm !important;
	}
}
.A4 {
  height: 297mm !important;
  width: 210mm !important;
	display: flex !important;
}

.preview-col {
  min-width: 210mm;
}

.preview-pane {
  overflow: visible;
  min-width: 210mm;
}

::v-deep .preview-pane .v-data-table__wrapper {
  overflow-x: hidden;
}


.MSPGOTHIC {
  font-family: "MS PGothic";
}

.MSGOTHIC {
  font-family: "MS Gothic",sans-serif;
}

.header-font {
  font-size: 18pt !important;
  color: #000;
  height: 32px !important;
}

.font-size-11 {
  font-size: 11pt !important;
}

.font-size-12 {
  font-size: 12pt !important;
}

.font-size-13 {
  font-size: 13pt !important;
}

.font-size-9 {
  font-size: 9pt !important;
}

.font-black {
  color: #000;
}

.text-vertical {
  writing-mode: vertical-rl;
  text-align: center;
  white-space: nowrap;
  margin: 0;
  line-height: 1em;
}

.border-top {
  border-top: solid 1px;
}

.border-right {
  border-right: solid 1px;
}

.border-top-left {
  border-top: solid 1px;
  border-left: solid 1px;
}

.border-top-right {
  border-top: solid 1px;
  border-right: solid 1px;
}

.border-box {
  border: solid 1px !important;
}

.border-tx {
  border-top: solid 1px;
  border-left: solid 1px;
  border-right: solid 1px;
}

.border-tr {
  border-top: solid 1px;
  border-right: solid 1px;
}

.border-bx {
  border-bottom: solid 1px !important;
  border-left: solid 1px;
  border-right: solid 1px;
}

.border-br {
  border-bottom: solid 1px !important;
  border-right: solid 1px;
}

/* tbody > tr > td {
  height: 25px !important;
} */

.cellHeight-35 {
  height: 35px !important;
}

.cellHeight-28 {
  height: 28px !important;
}

.cellHeight-24 {
  height: 24px;
}

.cellHeight-22 {
  height: 22px !important;
}

.cellHeight-8 {
  height: 8px !important;
}

.lineHeight {
  line-height: 1px;
}

/* v-simple-tableにデフォルトで付与してあるhoverを無効化 */
tr:hover {
  background-color: transparent !important;
}

thead:hover {
  background-color: transparent !important;
}

/* tbody > tr > td {
  border: solid 0.1px !important;
} */

/* v-simple-tableにデフォルトで付与してある下線を無効化 */
tbody > tr > td{
  border-bottom: none !important;
  border: none;
}

tfoot > tr > td {
  border-top: none !important;
}

.v-radio >>> .v-icon {
  font-size: 18px;
}

.v-input--radio-group {
  margin-top: 0px;
}

.v-radio >>> .v-input--selection-controls__input {
  margin-right: 0px !important;
}
</style>
